import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=7511bbb0&functional=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
import style0 from "./Badge.vue?vue&type=style&index=0&id=7511bbb0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports